export default "__VITE_ASSET__BW1IQ6jr__"